import React from 'react'
import { useLocation } from 'react-router-dom';
import quizResults from '../../../Interfaces/quizResults';
import quizResponseResults from '../../../Interfaces/quizResponseResults';
import ScoreViewResults from './ScoreViewResults';
interface props{
  fullName:string
}
function ScoreView({fullName}:props) {
    const location = useLocation();
    const state = location.state as { scoreResults: quizResponseResults } | undefined;
    const scoreResults = state?.scoreResults;
    const resultsName = scoreResults?.responseAnswerDto.total != undefined ? scoreResults?.responseAnswerDto.total * 100 : 0
    //console.log(scoreResults);
  return (
    <div>
      <div className='border p-3 rounded'>
          <div className='bg-body-secondary border p-3 rounded'>
            <h2 className='mb-0'>Notice Of Rating</h2>
          </div>
          <div className='mb-1'>
            <span>
              {fullName}
            </span >
          </div>
          <div className='mb-1'>
            <span>
              Please be informed that you{" "}  
              {resultsName >= 80 ? <strong>PASSED</strong> : <strong>FAILED</strong>} 
              {" "}the mock exam carreer service examination 
              Computer professional with a general rating of {scoreResults?.responseAnswerDto.total != undefined ? (scoreResults?.responseAnswerDto.total * 100).toFixed(2) : 0.00}{"/100"}
            </span>
          </div>
          <div className='mb-1'>
            <span>
              Below is your comparable performance in each of the subject areas of the test.
            </span>
          </div>
          <div>
            <table className="table table-bordered align-middle bor">
              <thead className="thead-light text-nowrap">
                <tr>
                  <th>
                    Verbal (30%)
                  </th>
                  <th>
                    Analytical (35%)
                  </th>
                  <th>
                    Numerical (30%)
                  </th>
                  <th>
                    General Info (5%)
                  </th>
                </tr>
              </thead>
              <tbody className="position-relative">
                <tr>
                  <td>
                      {scoreResults?.responseAnswerDto?.verbal != undefined ? ((scoreResults?.responseAnswerDto?.verbal / 15)*100).toFixed(2) : 0}
                  </td>
                  <td>
                      {scoreResults?.responseAnswerDto.analytical != undefined ? ((scoreResults?.responseAnswerDto.analytical / 18)*100).toFixed(2) : 0}
                  </td>
                  <td>
                      {scoreResults?.responseAnswerDto.numerical != undefined ? ((scoreResults?.responseAnswerDto.numerical / 15)*100).toFixed(2) : 0}
                  </td>
                  <td>
                      {scoreResults?.responseAnswerDto.generalInfo != undefined ? ((scoreResults?.responseAnswerDto.generalInfo / 2)*100).toFixed(2) : 0}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
      
      <div>
        <ScoreViewResults dataAnswered={scoreResults?.userAnswerWithQuestionDto} />
      </div>
       
    </div>
  )
}

export default ScoreView